import {useInjection} from "inversify-react";
import {useEffect, useState} from "react";
import ApiService from "../../services/apiService";
import {
    MenuCategoryApi,
    MenuCategoryCreateDto,
    Direction,
    MenuCategoryUpdateDto
} from "../../api";
import MenucategoriesList from "./menuCategoryList";
import MenuCategoryModalFormAddContainer from "./menuCategoryModalFormAddContainer/menuCategoryModalFormAddContainer";
import {generatePath, useNavigate} from "react-router-dom";
import {RoutingPaths} from "../routing/routingContainer";
import {Content} from "antd/es/layout/layout";
import {Layout, notification} from "antd";
import styles from "./menuCategoryListContainer.module.scss";

export default function MenuCategoryListContainer() {
    const apiService = useInjection(ApiService);
    const navigate = useNavigate();
    const [Menucategories, setMenucategories] = useState<any | null>();
    const [isAddFormVisible, setAddFormVisible] = useState(false);
    const [MenuCategoryModalFormContainerTitle, setMenuCategoryModalFormContainerTitle] = useState<string>();
    const [MenuCategoryToEdit, setMenuCategoryToEdit] = useState<MenuCategoryUpdateDto | null>(null);
    const [idMenuCategoryToEdit, setIdMenuCategoryToEdit] = useState<number | null>(null);


    const refreshMenucategoriesList = async () => {
        try {
            const Menucategories = await apiService.getApi(MenuCategoryApi).apiMenuCategoryGet();
            let sortedMenuCategory = Menucategories.data.sort((a, b) => {
                return a.position! - b.position!
            })
            setMenucategories(sortedMenuCategory)
        } catch (e: any) {
            console.log(e.response.data);
        }
    }

    useEffect(() => {
        refreshMenucategoriesList();
    }, [])

    const onAddClicked = () => {
        setMenuCategoryModalFormContainerTitle("Dodaj nową kategorię menu");
        setMenuCategoryToEdit(null);
        setIdMenuCategoryToEdit(null);
        setAddFormVisible(true);
    }
    const onPositionChangeClicked = async (id: number, direction: Direction) => {
        const menuCategories = await apiService.getApi(MenuCategoryApi).apiMenuCategoryPositionIdDirectionPatch(id, direction);
        let sortedMenuCategory = menuCategories.data.sort((a, b) => {
            return a.position! - b.position!
        })
        setMenucategories(sortedMenuCategory)
    }

    const onEditClicked = async (id: number) => {
        setMenuCategoryModalFormContainerTitle(`Edycja kategorii menu`);

        const response = await apiService.getApi(MenuCategoryApi).apiMenuCategoryIdGet(id);

        setMenuCategoryToEdit(response.data as MenuCategoryUpdateDto);
        setMenuCategoryModalFormContainerTitle(`Edycja kategorii menu: ${response.data.name}`);
        setIdMenuCategoryToEdit(id);
        setAddFormVisible(true);
    }

    const onDeleteClicked = async (id: number) => {
        const response = await apiService.getApi(MenuCategoryApi).apiMenuCategoryIdDelete(id)

        if (response.request.status !== 200) {
            console.log("Error occured while deleting data");
        } else {
            refreshMenucategoriesList();
        }
    }

    const onShowClicked = (id: number) => {
        navigate(generatePath(RoutingPaths.menuEntryTable.route.replace(":menuCategoryId", id.toString())));
    }

    const openNotification = (message: string) => {
        notification.info({
            message: message,
            description:
                'Aby wprowadzone zmiany były widoczne na stronie konieczna jest publikacja',
            placement:"top"
        });
    };

    const onSubmit = async (values: MenuCategoryCreateDto | MenuCategoryUpdateDto) => {
        try {
            if (MenuCategoryToEdit === null) {
                await apiService.getApi(MenuCategoryApi).apiMenuCategoryPost(values);
                openNotification("Pomyślnie dodano nowy wpis");
            } else if (idMenuCategoryToEdit !== null) {
                values.position = MenuCategoryToEdit.position;
                await apiService.getApi(MenuCategoryApi).apiMenuCategoryIdPut(idMenuCategoryToEdit, values)
                openNotification("Pomyślnie zaaktualizowano wpis");
            }
        } catch (e: any) {
            return e.response.data;
        }

        setAddFormVisible(false)
        refreshMenucategoriesList();
    }

    return <>
        <Layout style={{backgroundColor: "white"}}>
            <h1>Kategorie menu</h1>
            <Content className={styles.content}>
                <MenucategoriesList
                    data={Menucategories || null}
                    onAddClicked={onAddClicked}
                    onEditClicked={onEditClicked}
                    onDeleteClicked={onDeleteClicked}
                    onShow={onShowClicked}
                    onPositionChangeClicked={onPositionChangeClicked}

                />
                <MenuCategoryModalFormAddContainer
                    onFinish={() => setAddFormVisible(false)}
                    onSubmit={onSubmit}
                    addFormVisibility={isAddFormVisible}
                    title={MenuCategoryModalFormContainerTitle || ""}
                    MenuCategoryToEdit={MenuCategoryToEdit}
                />
            </Content>
        </Layout>
    </>
}
